import {Directive, TemplateRef} from "@angular/core";

/**
 * Структурная директива для переопределения шаблона области контента страницы.
 * @publicApi
 */
@Directive({selector: '[dxPageContent]'})
export class DxPageContentDirective {
  constructor(public template: TemplateRef<any>) { }
}
